import { createAction } from 'redux-actions';

export const getKytRulesRequest = createAction('GET_KYT_RULES_REQUEST');
export const getKytRulesSuccess = createAction('GET_KYT_RULES_SUCCESS');
export const getKytRulesFail = createAction('GET_KYT_RULES_FAIL');

export const updateKytRuleRequest = createAction('UPDATE_KYT_RULE_REQUEST');
export const updateKytRuleSuccess = createAction('UPDATE_KYT_RULE_SUCCESS');
export const updateKytRuleFail = createAction('UPDATE_KYT_RULE_FAIL');
